import { Box, Flex } from "@chakra-ui/layout"
import { useMemo } from "react"
import { ChatStyles } from "."
import { RoomBranding } from "../../../recoil/atoms/room/types"

function DaySplitter({
  date,
  styleschat,
  isMobile,
  isTransparent
}: {
  date: string
  styleschat: RoomBranding | ChatStyles
  isMobile?: boolean
  isTransparent?: boolean
  }) {

  const textColor = useMemo(() => {
    if (isTransparent) {
      return "white"
    }
    return styleschat?.servicePanelElementPrimaryText ?? "#2D3748"
  }, [isTransparent, styleschat?.servicePanelElementPrimaryText])

  const backgroundColor = useMemo(() => {
    if (isTransparent) {
      return "none"
    }

    return styleschat?.servicePanelElementBackground ?? "white"
  }, [isTransparent])

  const borderColor = useMemo(() => {
    return styleschat?.servicePanelElementBorder
      ? styleschat?.servicePanelElementBorder
      : "#E2E8F0"
  }, [
    styleschat?.servicePanelElementBorder
  ])

  return (
    <Flex
      flexDir="row"
      alignItems="center"
      fontSize="0.75rem"
      fontWeight="600"
      color={textColor}
      fontFamily={styleschat?.commentFontFamily ?? "inherit"}
      bgColor={isTransparent ? "rgba(0, 0, 0, 0.5)" : backgroundColor}
      border={`2px solid ${isTransparent ? "transparent" : borderColor}`}
      borderRadius="8px"
      padding="0rem .25rem"
      width="100%"
      gap=".5rem"
      marginTop=".5rem"
    >
      <Box
        flexGrow={1}
        height="1px"
        borderRadius="1px"
        backgroundColor={
          isTransparent ? "#FFFFFF" : styleschat?.servicePanelElementPrimaryText ?? "#718096"
        }
      />
      {date}
      <Box
        flexGrow={1}
        height="1px"
        borderRadius="1px"
        backgroundColor={
          isTransparent ? "#FFFFFF" : styleschat?.servicePanelElementPrimaryText ?? "#718096"
        }
      />
    </Flex>
  )
}

export default DaySplitter
